import { useContext, useEffect, useState } from 'react';
import { MapContext } from '../MapProvider';
import olDraw from 'ol/interaction/Draw';
const Draw = (props) => {
    const { type, style, geometryFunction, condition, source, active, drawend, drawstart } = props;
    const map = useContext(MapContext);
    const [draw, setDraw] = useState();
    const getDraw = () => {
        const options = { type, style, geometryFunction, condition, source };
        const draw = new olDraw(options);
        if (active !== undefined)
            draw.setActive(active);
        if (drawstart !== undefined)
            draw.on('drawstart', e => drawstart(e));
        if (drawend !== undefined)
            draw.on(['change:active', 'drawend'], e => drawend(e));
        return draw;
    };
    useEffect(() => {
        if (!map)
            return;
        const draw = getDraw();
        setDraw(draw);
        return () => {
            map.removeInteraction(draw);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);
    useEffect(() => {
        if (!map)
            return;
        if (draw !== undefined)
            map.removeInteraction(draw);
        const newDraw = getDraw();
        setDraw(newDraw);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, type, active]);
    useEffect(() => {
        if (!(draw && map))
            return;
        map.addInteraction(draw);
        return () => {
            map.removeInteraction(draw);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [draw]);
    return null;
};
export default Draw;
